import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { ChevronLeft, ChevronRight } from 'lucide-react';

import Bimg1 from '../assest/Records/blooddonation/image1.png';
import Bimg2 from '../assest/Records/blooddonation/image2.png';
import Bimg3 from '../assest/Records/blooddonation/image3.png';

import Dimg1 from '../assest/Records/Dentalcheckup/image1.png';
import Dimg2 from '../assest/Records/Dentalcheckup/image2.png';
/* import Dimg3 from '../assest/Records/Dentalcheckup/image3.png';
import Dimg4 from '../assest/Records/Dentalcheckup/image4.png'; */
import Dimg5 from '../assest/Records/Dentalcheckup/image5.png';
import img1 from '../assest/capms/redcross_images/image7.JPG'
import img2 from '../assest/capms/redcross_images/image12.JPG'
import img3 from '../assest/capms/redcross_images/image13.JPG'
import img4 from '../assest/capms/redcross_images/image14.JPG'
import img5 from '../assest/capms/redcross_images/image17.JPG'
import img6 from '../assest/capms/redcross_images/image18.JPG'
import img7 from '../assest/capms/redcross_images/image20.JPG'
import img8 from '../assest/capms/redcross_images/image21.JPG'
import img9 from '../assest/capms/redcross_images/image15.JPG'

const fadeUp = {
  hidden: { opacity: 0, y: 60 },
  visible: {
    opacity: 1,
    y: 0,
    transition: { duration: 0.8, ease: "easeOut" }
  }
};
  const RedCrossCarousel = ({ images }) => {
  const [current, setCurrent] = useState(0);

  const nextSlide = () => {
    setCurrent((prev) => (prev + 1) % images.length);
  };

  const prevSlide = () => {
    setCurrent((prev) => (prev - 1 + images.length) % images.length);
  };

    return (
      <div className="relative w-full overflow-hidden rounded-3xl shadow-2xl">
        <img
          src={images[current]}
          alt="Red Cross Activity"
          className="w-full h-[260px] md:h-[450px] lg:h-[650px] xl:h-[500px] 2xl:h-[550px] 2xl:object-[center_10px] object-cover object-top transition-all duration-500"
        />
  
        {/* Left Arrow */}
        <button
          onClick={prevSlide}
          className="absolute left-4 top-1/2 -translate-y-1/2 bg-black/40 hover:bg-black/60 text-white p-3 rounded-full z-10"
        >
          <ChevronLeft size={28} />
        </button>
  
        {/* Right Arrow */}
        <button
          onClick={nextSlide}
          className="absolute right-4 top-1/2 -translate-y-1/2 bg-black/40 hover:bg-black/60 text-white p-3 rounded-full z-10"
        >
          <ChevronRight size={28} />
        </button>
  
        {/* Dots */}
        <div className="absolute bottom-4 left-0 right-0 flex justify-center gap-2">
          {images.map((_, index) => (
            <button
              key={index}
              onClick={() => setCurrent(index)}
              className={`rounded-full transition-all ${
                current === index
                  ? 'bg-white w-8 h-2'
                  : 'bg-white/50 w-2 h-2'
              }`}
            />
          ))}
        </div>
      </div>
    );
  };
  const redCrossImages = [
    img2,
    img3,
    img5,
    img6,
    img7,
    img8,
  ];
  
  
const ImageCarousel = ({ images }) => {
  const [currentIndex, setCurrentIndex] = useState(0);

  const prevSlide = () => {
    setCurrentIndex(
      currentIndex === 0 ? images.length - 1 : currentIndex - 1
    );
  };

  const nextSlide = () => {
    setCurrentIndex(
      currentIndex === images.length - 1 ? 0 : currentIndex + 1
    );
  };

  return (
    <div className="relative w-full h-[200px] sm:h-[250px] md:h-[450px] lg:h-[350px] xl:h-[400px] overflow-hidden rounded-2xl shadow-2xl bg-gray-100">
      {/* Image with proper object-fit */}
      <motion.div
        key={currentIndex}
        className="w-full h-full"
        initial={{ opacity: 0, scale: 1.05 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ duration: 0.7 }}
      >
        <img 
          src={images[currentIndex]} 
          alt="Carousel"
          className="w-full h-full object-cover object-top"
        />
      </motion.div>

      {/* Navigation Arrows */}
      <button
        onClick={prevSlide}
        className="absolute top-1/2 left-3 -translate-y-1/2 bg-black/40 hover:bg-black/60 text-white p-2 rounded-full transition-all duration-300 z-10"
      >
        <ChevronLeft size={34} />
      </button>
      <button
        onClick={nextSlide}
        className="absolute top-1/2 right-3 -translate-y-1/2 bg-black/40 hover:bg-black/60 text-white p-2 rounded-full transition-all duration-300 z-10"
      >
        <ChevronRight size={34} />
      </button>

      {/* Dots */}
      <div className="absolute bottom-3 left-0 right-0 flex justify-center gap-2 z-10">
        {images.map((_, i) => (
          <button
            key={i}
            onClick={() => setCurrentIndex(i)}
            className={`transition-all duration-300 rounded-full ${
              currentIndex === i
                ? "bg-white w-6 h-2"
                : "bg-white/50 w-2 h-2 hover:bg-white/80"
            }`}
          />
        ))}
      </div>
    </div>
  );
};

const Records = () => {
  const recordData = [
    {
      id: 1,
      title: "World's Largest Dental Health Check",
      description:
        "Achieved Guinness World Record for performing dental checkups for 21,233 children in just 9 hours with 800 doctors.",
      images: [Dimg1, Dimg2, Dimg5],
      stats: ["21,233 Children", "9 Hours", "800 Doctors"],
      color: "from-blue-50 to-blue-100"
    },
    {
      id: 2,
      title: "Massive Blood Donation Sign-up",
      description:
        "Received Guinness World Record on 15th February 2020 at Andhra Loyola College with 10,217 students.",
      images: [Bimg1, Bimg2, Bimg3],
      stats: ["10,217 Students", "Feb 15, 2020", "Andhra Loyola College"],
      color: "from-red-50 to-red-100"
    }
  ];

  return (
    <div className="w-full bg-white min-h-screen py-12">
      {/* HEADER */}
      <motion.div
        className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 text-center mb-16"
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true }}
        variants={fadeUp}
      >
        <span className="inline-block px-4 py-1.5 bg-blue-100 text-blue-600 text-sm font-bold rounded-full mb-4">
          Guinness World Records
        </span>
        <h1 className="text-3xl md:text-5xl font-black text-gray-900 mb-4">
          Dr. Sridhar Oral Health Foundation
        </h1>
        <div className="w-24 h-1 bg-blue-600 mx-auto mb-6"></div>
        <p className="max-w-2xl mx-auto text-base md:text-lg text-gray-600">
          Breaking boundaries and setting global standards in healthcare and social responsibility.
        </p>
      </motion.div>

      {/* RECORDS - Professional Grid Layout */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 space-y-20">
        {recordData.map((record, index) => (
          <motion.div
            key={record.id}
            className={`grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-12 items-center ${
              index % 2 !== 0 ? 'lg:grid-flow-dense' : ''
            }`}
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true, amount: 0.2 }}
            variants={fadeUp}
          >
            {/* IMAGE SECTION */}
            <motion.div
              className={`relative ${index % 2 !== 0 ? 'lg:order-2' : ''}`}
              initial={{ opacity: 0, x: index % 2 === 0 ? -50 : 50 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.8 }}
            >
              {/* Decorative badge */}
{/*               <div className="absolute -top-3 -left-3 z-10 bg-red-600 text-white px-4 py-1.5 rounded-full text-sm font-bold shadow-lg">
                #{index + 1}
              </div> */}
              <ImageCarousel images={record.images} />
            </motion.div>

            {/* TEXT SECTION */}
            <motion.div
              className={`space-y-5 ${index % 2 !== 0 ? 'lg:order-1' : ''}`}
              initial={{ opacity: 0, x: index % 2 === 0 ? 50 : -50 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.8, delay: 0.2 }}
            >
              {/* Badge */}
              <div className="inline-flex items-center gap-2 px-4 py-2 bg-gradient-to-r from-blue-50 to-blue-100 rounded-full border border-blue-200">
                <span className="text-blue-600 text-xs font-bold uppercase tracking-wider">
                  🏆 Guinness World Record
                </span>
              </div>

              {/* Title */}
              <h2 className="text-3xl sm:text-4xl font-extrabold text-gray-900 leading-tight">
                {record.title}
              </h2>

              {/* Description */}
              <p className="text-base sm:text-lg text-gray-600 leading-relaxed">
                {record.description}
              </p>

              {/* Stats Grid */}
              <div className="grid grid-cols-3 gap-3 pt-2">
                {record.stats.map((stat, i) => (
                  <motion.div
                    key={i}
                    whileHover={{ y: -4, scale: 1.02 }}
                    className="bg-gray-50 p-3 rounded-xl border border-gray-100 text-center hover:shadow-md transition-all duration-300"
                  >
                    <div className="text-xs text-gray-500 uppercase tracking-wider font-semibold">
                      {i === 0 ? 'Total' : i === 1 ? 'Duration' : 'Location'}
                    </div>
                    <div className="text-sm font-bold text-gray-800 mt-1">
                      {stat}
                    </div>
                  </motion.div>
                ))}
              </div>

              {/* CTA Button */}
              <motion.button
                whileHover={{ scale: 1.02 }}
                whileTap={{ scale: 0.98 }}
                className="mt-2 px-6 py-3 bg-gradient-to-r from-blue-600 to-blue-700 text-white font-bold rounded-full hover:shadow-lg transition-all duration-300"
              >
                Learn More →
              </motion.button>
            </motion.div>
          </motion.div>
        ))}
      </div>

      {/* QUOTE SECTION */}
      <motion.div
        className="mt-20 max-w-4xl mx-auto text-center px-6 py-12"
        initial={{ opacity: 0, y: 40 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 1 }}
      >
        <blockquote className="text-xl md:text-2xl italic text-gray-500">
          "Our mission is to bring world-class healthcare awareness to every corner of society, one smile at a time."
        </blockquote>
      </motion.div>

      <section className="py-20">
  <motion.div
    className="text-center mb-12"
    initial="hidden"
    whileInView="visible"
    viewport={{ once: true }}
    variants={fadeUp}
  >
    <motion.h2
      className="text-3xl md:text-5xl font-black text-slate-900 mb-6"
      initial={{ opacity: 0, y: 40 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
    >
      Our Collaboration with the Red Cross
    </motion.h2>

    <p className="max-w-4xl mx-auto text-slate-600 text-base md:text-lg leading-relaxed px-4">
      Through our partnership with the Red Cross, we have actively participated
      in community healthcare initiatives, oral health awareness campaigns,
      humanitarian outreach programs, and large-scale public service activities.
      Together, we continue to promote preventive healthcare and improve the
      well-being of communities through education, service, and compassion.
    </p>
  </motion.div>
<div className="max-w-6xl mx-auto mt-12">
    <RedCrossCarousel images={redCrossImages} />
</div>
</section>
    </div>

    
  );
};

export default Records;